class MothersTypeRhFactor {
    public RhType: string;
    public Antibodies0: string;
    public Antibodies1: string;
    public Antibodies2: string;

    constructor(fields?: Partial<MothersTypeRhFactor>) {
        Object.assign(this, fields);
    }
}

export { MothersTypeRhFactor };
